import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import appConfig from '../../../config/config';

import { Spinner, TabPane, Nav, NavItem, NavLink, Card, CardBody, Button, CardTitle, CardText, Row, Col, FormGroup } from 'reactstrap';
import { renderInput, renderTextArea, renderDatePicker, renderDropdown, renderMultiselect, renderCheckbox } 
from "../../common/renderinput";
import validate from './validate'
import CardHeader from 'reactstrap/lib/CardHeader';
import { connect } from "react-redux";
import {Loading,LoadingDone,Reset,Success,Error} from "../../../actions/loading"
import axios from "axios";
import Banner from "../../common/banner";

var userTypes = [
    {textField : 'MTS', valueField:100},
    {textField : 'TOWER', valueField:101},
    {textField : 'ROYAL', valueField:102},
    {textField : 'OUTBOX', valueField:111},
];
class UserEditForm extends Component {
    handleSubmit=(values)=>{
        console.log(values)
        this.props.Loading();
        axios.post(
            appConfig.apiGateway.updateOrderUrl,
            JSON.stringify({
                ...values,
                Action: "UpdateUser",
                UserName: this.props.session.session.user.name
            }),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then((response) => {
            this.props.LoadingDone()
            if (response.data.body.status) {
                this.props.Success('user updated')
                return;
            }
            else {
                this.props.Error('Unable to update user')
            }
        },
        (error) => {
            this.props.LoadingDone()
            this.props.Error('Unable to update user')
        }
        )
    }
    render(){
        return (
            <>
            <form onSubmit={this.props.handleSubmit(this.handleSubmit)}>
            <Row form>
            <Col md={6}>
            {this.props.loading.showBanner && (
                      <Banner
                        Close={()=> this.props.Reset()}
                        message={this.props.loading.message}
                        IsSuccess={this.props.loading.isSuccess}
                      />
                    )}
                <Card className="w-100">
                    <CardHeader as="" >User</CardHeader>
                <CardBody>
                    <FormGroup>
                        <Field name="EMAIL" component={renderInput}     isLabel={true} label="Email" />
                        <Field name="FIRSTNAME" component={renderInput}   isLabel={true}   label="Name" />
                        <Field name="MOBILEPHONE" component={renderInput} isLabel={true}   label="Phone" />
                        <Field name="LOGINID" component={renderInput}     isLabel={true}   label="AWS Id" />
                        <Field name="STATUS" component={renderInput}      isLabel={true}   label="Status" />
                        <Field name="COMPANY_ID" component={renderDropdown}      
                                data={userTypes} valueField={'valueField'} textField={'textField'}
                            isLabel={true}   label="Company" />
                    </FormGroup>
                    <Button  type="submit" color="primary">
                      {this.props.loading.loading && <Spinner />}
                      {!this.props.loading.loading && <span>Save</span>}
                    </Button>
                    <Button
                      color="secondary">
                      Cancel
                    </Button>
                </CardBody>
                </Card>
            </Col>
        </Row>
        </form>
        </>
        )
    }
}


var userEditForm = reduxForm({
    form: 'CreateUserForm', // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate,
    enableReinitialize: true
  })(UserEditForm)

  userEditForm = connect(
        state => ({
            initialValues: state.UserData.user,
            session: state.session,
            loading : state.loading
        }),
        {LoadingDone,Loading,Success,Error,Reset}
    )(userEditForm);
  export default userEditForm